import type { ProjectId } from 'owa-timestream-types';
import { getAssets } from 'owa-timestream-store';
import { getAssetDescriptor } from 'owa-timestream-asset-sdk';
import loc, { format } from 'owa-localize';
import { canvasPreviewAltText, assetAltText } from './getCanvasPreviewAriaLabel.locstring.json';

export default function getCanvasPreviewAriaLabel(
    projectId: ProjectId,
    name: string,
    description: string
) {
    const assets = getAssets(projectId);

    const assetsString = assets
        .map(([id, asset]) => {
            const descriptor = getAssetDescriptor(asset.type)!;
            const toolName = descriptor.getToolName();
            const displayName = descriptor.getTitleString(asset.payload);
            return format(assetAltText, toolName, displayName);
        })
        .join(' ');

    return loc(canvasPreviewAltText, name, description, assetsString);
}
